<template>

  <div class="resume">
    <div class="basic">
      <ul class="ui-list">
        <li class="ui-border-t">
          <div class="basic-title">姓名：</div>
          <div class="">
            <input type="text" v-model="resumeInfo.name" maxlength="10">
          </div>
        </li>
        <li class="ui-border-t">
          <div class="basic-title">性别：</div>
          <div class="basic-sex">
            <ul class="ui-row-flex"><li v-for="(sex,index) in sexs" @click="select(index)" :class="{clicked:index===activeIndex}" :key="sex" class="ui-col ui-col sexbtn">{{ sex }}</li></ul>
          </div>
        </li>
        <li class="ui-border-t">
          <div class="basic-title">婚姻状况：</div>
          <div class="">
            <input type="text" v-model="resumeInfo.marriage" maxlength="10">
          </div>
        </li>
      </ul>
    </div>
  
    <div class="exprence">
      <ul class="ui-list">
        <li class="ui-border-t">
          <div class="basic-title">工作年限：</div>
          <div class="">
            <input type="tel" v-model="resumeInfo.years" maxlength="2" style="width:1.45em">年
          </div>
        </li>
        <li class="ui-border-t">
          <div class="basic-title">所在公司：</div>
          <div class="">
            <input type="text" v-model="resumeInfo.company" maxlength="10">
          </div></li>
          <li class="ui-border-t">
            <div class="basic-title">担任职务：</div>
            <div class="">
              <input type="text" v-model="resumeInfo.position" maxlength="15">
            </div>
          </li>
      </ul>
    </div>
  
    <div class="school">
      <ul class="ui-list">
        <li class="ui-border-t">
          <div class="basic-title">毕业学校：</div>
          <div class="">
            <input type="text" v-model="resumeInfo.school" maxlength="20">
          </div>
        </li>
        <li class="ui-border-t">
          <div class="basic-title">所学专业：</div>
          <div class="">
            <input type="text" v-model="resumeInfo.major" maxlength="10">
          </div>
        </li>
        <li class="ui-border-t">
          <div class="basic-title">学历：</div>
          <div class="">
            <input type="text" v-model="resumeInfo.education" maxlength="10">
          </div>
        </li>
      </ul>
    </div>
  
    <div class="contact">
      <ul class="ui-list">
        <li class="ui-border-t">
          <div class="basic-title">联系电话：</div>
          <div class="">
            <input type="tel" v-model="resumeInfo.tel" maxlength="11">
          </div>
        </li>
        <li class="ui-border-t">
          <div class="basic-title">电子邮箱：</div>
          <div class="">
            <input type="email" name="email" v-model="resumeInfo.email" maxlength="30" >
          </div>
        </li>
      </ul>
    </div>

    <div class="bottom">
       <span class="tip">请将详细简历发送至该公司邮箱：{{companyEmail}}</span>
       <button class="btn" v-on:click="submit">投递简历</button>
    </div>
  </div>

</template>

<script>
import api from '@/script/util'
export default {
  name: '', // 填写简历
  data () {
    return {
      resumeInfo: {
        name: '',
        marriage: '',
        years: '',
        company: '',
        position: '',
        school: '',
        major: '',
        education: '',
        tel: '',
        email: ''
      },
      sexs: ['男', '女'],
      activeIndex: 0,
      companyEmail: ''
    }
  },
  methods: {
    submit: function () {
      let recommendId = this.$route.params.recommendId
      let positionId = this.$route.params.id
      let subId = this.$route.params.subId
      let params = {
        recommendId: recommendId || '',
        positionId: positionId || '',
        subId: subId || '',
        name: this.resumeInfo.name || '',
        sex: this.activeIndex,
        marriage: this.resumeInfo.marriage || '',
        jobLife: this.resumeInfo.years || '',
        company: this.resumeInfo.company || '',
        position: this.resumeInfo.position || '',
        school: this.resumeInfo.school || '',
        major: this.resumeInfo.major || '',
        education: this.resumeInfo.education || '',
        connection: this.resumeInfo.tel || '',
        email: this.resumeInfo.email || ''
      }
      // 不为空的判断，以及电话号码和email的判断
      for (var val in params) {
        if (params[val] === '') {
          if (val === 'name') {
            alert('姓名不能为空')
            return false
          } else if (val === 'marriage') {
            alert('婚姻状况不能为空')
            return false
          } else if (val === 'jobLife') {
            alert('工作年限不能为空')
            return false
          } else if (val === 'company') {
            alert('所在公司不能为空')
            return false
          } else if (val === 'position') {
            alert('担任职务不能为空')
            return false
          } else if (val === 'school') {
            alert('毕业学校不能为空')
            return false
          } else if (val === 'major') {
            alert('所学专业不能为空')
            return false
          } else if (val === 'education') {
            alert('学历不能为空')
            return false
          } else if (val === 'connection') {
            alert('联系电话不能为空')
            return false
          } else if (val === 'email') {
            alert('电子邮件不能为空')
            return false
          }
        }
      }
      if (!this.checkTel(params.connection)) {
        alert('请输入正确的手机号码')
        return false
      }
      if (!this.checkEmail(params.email)) {
        alert('请输入正确的电子邮件')
        return false
      }
      let Info = ''
      for (var param in params) {
        Info += '"' + param + '":"' + (params[param] === '' ? '' : params[param]) + '",'
      }
      Info = '{' + Info.substr(0, Info.length - 1) + '}'
      let key = {
        resumeInfo: Info
      }
      api.PostResume(key)
      .then(res => {
        if (res.status === 100) {
          alert('简历已投递成功')
        } else {
          alert('简历投递失败')
        }
      })
    },
    select (index) {
      this.activeIndex = index
    },
    checkTel (tel) {
      let reg = /^0?1[0-9]\d{9}$/
      return reg.test(tel)
    },
    checkEmail (email) {
      let reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/
      return reg.test(email)
    }
  },
  created: function () {
    document.title = '填写简历'
    this.companyEmail = this.$route.params.companyEmail
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.resume{
  background-color: #ebebeb;
}
.resume .ui-list>li {
  height: 2.2rem;
  position: relative;
  -webkit-box-align: center;
}

.basic {
  padding-top: .4rem;
}

.basic-title {
  width: 4.75rem;
  padding-left: .75rem;
}

input {
  background: none;
  outline: none;
  border: 0px;
}

.basic-sex {
  padding-right: .75rem;
  /*float: right;*/
  display: flex;
  -webkit-box-flex: 1;
  justify-content: flex-end;
}
.ui-row-flex{
  width: auto;
}
.sexbtn {
  width: 3.35rem;
  height: 1.45rem;
  border: 2px solid #aaa;
  border-radius: .1rem;
  color: #aaa;
  text-align: center;
  line-height: 1.35rem;
}

.clicked {
  background-color: #ffc001;
  border: 2px solid #ffc001;
  color: #333;
}
.sexbtn:nth-child(2){
  margin-left: .6em;
}

.exprence,
.school,
.contact {
  margin-top: .4rem;
}
.bottom{
  padding: .75em;
}
.tip{
  color: #aaa;
  font-size: .6em;
  display: block;
  margin-bottom: .75em;
}
.btn{
  height: 2.2rem;
  color: #333;
  background-color: #ffc001;
  width: 100%;
  display: block;
  border-radius: .2em;
  font-size: 1.2em
}
</style>



// WEBPACK FOOTER //
// resume.vue?93184e22